import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

export const createPaymentIntent = createAsyncThunk(
  "payments/createPaymentIntent",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.post("create-payment-intent", {});
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const confirmPayment = createAsyncThunk(
  "payments/confirmPayment",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { payment_intent_id } = formInfo;
      const res = await api.post("confirm-payment", { payment_intent_id });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const createPaymentIntentExpired = createAsyncThunk(
  "payments/createPaymentIntentExpired",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { email } = formInfo;
      const res = await api.post("create-payment-intent-expired", { email });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const confirmPaymentExpired = createAsyncThunk(
  "payments/confirmPaymentExpired",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { email, payment_intent_id } = formInfo;
      const res = await api.post("confirm-payment-expired", { email, payment_intent_id });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
